module.exports = __webpack_public_path__ + "static/media/family_purple.b4065eeb.png";